import { render, staticRenderFns } from "./update.vue?vue&type=template&id=629312cd&scoped=true&"
import script from "./update.js?vue&type=script&lang=js&"
export * from "./update.js?vue&type=script&lang=js&"
import style0 from "./update.vue?vue&type=style&index=0&id=629312cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629312cd",
  null
  
)

export default component.exports